import { render, staticRenderFns } from "./EnacCustomAtplResourceEditTopBox.vue?vue&type=template&id=b689f64e"
import script from "./EnacCustomAtplResourceEditTopBox.vue?vue&type=script&lang=js"
export * from "./EnacCustomAtplResourceEditTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports